export const cloneFileList = (fileList: FileList | undefined) => {
  if (fileList === undefined) return undefined;
  const dataTransfer = new DataTransfer();
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < fileList.length; i++) {
    const clonedFile = new File([fileList[i]], fileList[i]?.name, {
      type: fileList[i]?.type,
      lastModified: fileList[i]?.lastModified,
    });
    dataTransfer.items.add(clonedFile);
  }
  return dataTransfer.files;
};
